import React from 'react'
import ResultItem from './ResultItem'

const PackResultList = ({ orderIdCrm, resultCheck }) => {
  return (
    <div className='packResultBlock'>
        <p className='packResultBlock__text'>Перевірте, чи вірно отримано товари з замовлення? Якщо так, то створіть партію</p>
        <div className='packResultBlock__list'>
            <ResultItem
                text='Замовлення в CRM №: '
                value={orderIdCrm}
            />
            <ResultItem 
                text='Тип замовлення: '
                value={
                    resultCheck.customerType === 'aoz' ? 'АОЗ контракт' :
                    resultCheck.customerType === 'commercial' ? 'Комерційний контракт' : ''
                }
            />
            <ResultItem 
                text='Тип партії: '
                value={resultCheck.packType ? resultCheck.packType.name : ''}
            />
            <ResultItem 
                text='Кількість партій, шт: '
                value={resultCheck.countPacks}
            />
            <ResultItem 
                text='Кількість дронів (загалом), шт: '
                value={resultCheck.countDrones}
            />
            <ResultItem 
                text='Тип дронів: '
                value={resultCheck.drone ? resultCheck.drone.name : ''}
            />
            <ResultItem 
                text='Тип котушок: '
                value={resultCheck.bobbin ? resultCheck.bobbin.name : ''}
            />
            <ResultItem 
                text='Тип батарейок: '
                value={resultCheck.battery ? resultCheck.battery.name : ''}
            />
        </div>
    </div>
  )
}

export default PackResultList